import type { CommissionRule } from '../types'
import {
  evaluateCommissionRuleForSale,
  type CommissionRuleSaleEvalContext,
} from './commissionRuleSaleEvaluation'

export function commissionRuleAppliesToManualSaleAdd(
  rule: CommissionRule,
  ctx: CommissionRuleSaleEvalContext,
): boolean {
  if (!rule.isActive || rule.isMandatory) return false
  return evaluateCommissionRuleForSale(rule, ctx).applicable
}
